<template>
  <section class="form-surface">
    <div class="form-panel">
      <h1>Verify email</h1>
      <div class="workspace-alert">{{ message }}</div>
      <RouterLink class="app-link" to="/login">Go to login</RouterLink>
    </div>
  </section>
</template>

<script setup lang="ts">
import { onMounted, ref } from 'vue';
import { RouterLink, useRoute } from 'vue-router';
import { CommandsService } from '../api/generated';
import { getErrorMessage } from '../stores/session';

const route = useRoute();
const message = ref('Verifying email.');

onMounted(async () => {
  const token = typeof route.query.token === 'string' ? route.query.token : '';
  if (!token) {
    message.value = 'Verification token is missing.';
    return;
  }

  try {
    await CommandsService.commandVerifyEmailCommand({ requestBody: { token } });
    message.value = 'Email verified.';
  } catch (error) {
    message.value = getErrorMessage(error, 'Unable to verify email.');
  }
});
</script>
